'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { AppStoreButtons } from '@marketplace-web/web-to-app/web-to-app-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const AboutAppBanner = () => {
  const translate = useTranslate('about_mission.download')

  return (
    <>
      <Spacer size="x4-large" />
      <div className="u-tablets-up-only">
        <Spacer size="x4-large" />
      </div>
      <div className="u-phones-only">
        <div className="about__section">
          <Text as="h3" alignment="left" type="heading-xxl">
            {translate('title')}
          </Text>
          <Text as="p" alignment="left" type="body">
            {translate('text')}
          </Text>
          <Spacer size="x2-large" />
          <AppStoreButtons />
        </div>
        <Spacer size="x4-large" />
      </div>
    </>
  )
}

export default AboutAppBanner
